import {  HttpService } from "@/core";
import { BaseReq, BaseResp } from "@/core/interface";

export class FlowTemplateResp extends BaseResp {
    bizType: string | undefined = '';
    bizTypeName: string | undefined = '';
    moduleName: string | undefined = '';
    moduleType: string | undefined = '';
  }

export class MoreFlowService {
  static useFlowTemplateApi() {
    const api = ( data: any) =>
      HttpService.axios({
        method: "POST",
        url:'/examine_template/examineTemplateSelectByBizType',
        data,
      });
    return HttpService.useRequest<FlowTemplateResp>(api);
  }

  static useFormBindFlowApi() {
    const api = ( data: any) =>
      HttpService.axios({
        method: "POST",
        url: '/examine_template_cache/add',
        data,
      });
    return HttpService.useRequest<any>(api);
  }
}
